import Vue from 'vue'
import Router from 'vue-router'
import P404 from '@/pages/Page404'

Vue.use(Router)

export default new Router({
    mode: 'hash',
    routes: [

        { path: '/', redirect: '/home' },
        {
            path: '/home',
            component: () => import('@/pages/HomePage'),
            props: true
        },
        // {
        //     path: '/gg',
        //     component: () => import('@/pages/GgPage'),
        //     props: true
        // },
        // {
        //     path: '/bb',
        //     component: () => import('@/pages/BbPage'),
        //     props: true
        // },
        // {
        //     path: '/tt',
        //     component: () => import('@/pages/TtPage'),
        //     props: true
        // },
        { path: '/*', name: '404', component: P404 }

        
    ]
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


// WEBPACK FOOTER //
// ./src/router/index.js